<div class="outside-border" [style.background-color]="viewModel.borderColor$ | async">
  <div
    class="main-content"
    [style.width]="viewModel.borderLeftAndRightAdjustment$ | async"
    [style.height]="viewModel.borderTopAndBottomAdjustment$ | async"
    [style.background-color]="viewModel.cardColor$ | async">
    <app-print-card-background-image-with-color-overlay-and-opacity [cardBackground]="cardBackground">
    </app-print-card-background-image-with-color-overlay-and-opacity>
  </div>
</div>
